import { __directlySetCSSColorPaletteVariables } from '@design/Theme/Palette';
import type { PaletteName } from '@design/Theme/Palette/types';
import { useColorPaletteOverrideStore } from 'lib/stores/colorPaletteOverrideStore';

/**
 * Pins the palette an embed (or the gallery preview) asked for.
 *
 * `__directlySetCSSColorPaletteVariables` on its own only wins once. The main-app colorPalette
 * bridge re-applies `temporaryColorPalette ?? userChosenColorPalette` on every auth change,
 * userProperties cache write, prefers-color-scheme change and pathname change, and
 * `startAppEffects` kicks off `loadUserSession()` right after attaching it. So for a visitor
 * who has a Kalshi session, the userProperties fetch resolves *after* the widget's mount effect
 * and re-applies their account theme over the embedder's choice. On a light embed that flips
 * `--fill-x10` to white and makes text invisible against the white surface.
 *
 * Writing `temporaryColorPalette` makes the embedder's choice win every re-application rather
 * than just the first. The direct variable write is kept because the gallery renders without
 * the bridge attached, so nothing else would apply the store change there.
 */
export function pinEmbedPalette(palette: PaletteName): void {
    useColorPaletteOverrideStore.getState().actions.paletteForced(palette);
    __directlySetCSSColorPaletteVariables(palette);
}
